export default function () {
    var linkList = document.querySelectorAll('a');

    if (linkList.lenght !== 0) {
        for (let i = 1; i < linkList.length; i++) {
            const parent = linkList[i].parentElement;
            if (parent.innerHTML.indexOf('[[') !== -1 && parent.innerHTML.indexOf(']]') !== -1) {
                parent.firstChild.classList.add('btn', 'btn-primary');
                parent.innerHTML = parent.innerHTML.replace('[[', '<i class="far fa-arrow-right"></i><span>');
                parent.innerHTML = parent.innerHTML.replace(']]', '</span>');
            }
        }
    }
}
